import {
  EMPLOYMENT_NOT_JOIN,
  OPTIONS,
  SEARCH_CONDITION_ITEM_TITLE,
  WORKSTYLE,
} from '@doda/common/src/constants/screenStructure/searchConditionItems';
import {
  AVERAGE_AGE_VALUE,
  BENEFITS_VALUE,
  EMPLOYMENT_VALUES,
  HOLIDAY_AND_WAY_OF_WORKING_VALUE,
  LANGUAGE_VALUE,
  POSITIONS_VALUE,
  REQUIREMENT_VALUES,
  WORKPLACE_ENVIRONMENT_VALUE,
} from '@doda/common/src/constants/searchConditionLabelRequestValues';
import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';

/**
 * 検索用こだわり条件パラメータをもとに求人情報取得APIリクエストパラメータを生成
 * @param optionParamList 検索用こだわり条件のパラメータ ex)['17']
 * @returns こだわり条件の求人情報取得APIリクエストパラメータ
 */
export const createOpParams = (optionParamList: string[] | undefined) => {
  const employmentId: string[] = EMPLOYMENT_NOT_JOIN.list.map(
    (item) => item.id
  );
  const workstyleId: string[] = WORKSTYLE.map((item) => item.id);
  const requirementsId = OPTIONS.find(
    (obj) => obj.title === SEARCH_CONDITION_ITEM_TITLE.REQUIREMENT
  )?.list.map((item) => item.id);
  const workplaceEnvironmentId = OPTIONS.find(
    (obj) => obj.title === SEARCH_CONDITION_ITEM_TITLE.WORKPLACE_ENVIRONMENT
  )?.list.map((item) => item.id);
  const benefitId = OPTIONS.find(
    (obj) => obj.title === SEARCH_CONDITION_ITEM_TITLE.BENEFIT
  )?.list.map((item) => item.id);
  const languageId = OPTIONS.find(
    (obj) => obj.title === SEARCH_CONDITION_ITEM_TITLE.LANGUAGE
  )?.list.map((item) => item.id);
  const positionsId = OPTIONS.find(
    (obj) => obj.title === SEARCH_CONDITION_ITEM_TITLE.POSITION
  )?.list.map((item) => item.id);
  const averageAgeId = OPTIONS.find(
    (obj) => obj.title === SEARCH_CONDITION_ITEM_TITLE.AVERAGE_AGE
  )?.list.map((item) => item.id);
  return {
    isNewArrival: hasOptionParam(
      optionParamList,
      OP_SEARCH_ITEMS.newArrival.id
    ),
    isNearDeadline: hasOptionParam(
      optionParamList,
      OP_SEARCH_ITEMS.deadline.id
    ),
    employmentStatus: hasOptionParam(optionParamList, employmentId)
      ? createParam(optionParamList, EMPLOYMENT_VALUES)
      : undefined,
    holidayAndWayOfWorking: hasOptionParam(optionParamList, workstyleId)
      ? createParam(optionParamList, HOLIDAY_AND_WAY_OF_WORKING_VALUE)
      : undefined,
    requirements: hasOptionParam(optionParamList, requirementsId)
      ? createParam(optionParamList, REQUIREMENT_VALUES)
      : undefined,
    workplaceEnvironment: hasOptionParam(
      optionParamList,
      workplaceEnvironmentId
    )
      ? createParam(optionParamList, WORKPLACE_ENVIRONMENT_VALUE)
      : undefined,
    welfareBenefits: hasOptionParam(optionParamList, benefitId)
      ? createParam(optionParamList, BENEFITS_VALUE)
      : undefined,
    languageSkills: hasOptionParam(optionParamList, languageId)
      ? createParam(optionParamList, LANGUAGE_VALUE)
      : undefined,
    positions: hasOptionParam(optionParamList, positionsId)
      ? createParam(optionParamList, POSITIONS_VALUE)
      : undefined,
    employeeAverageAge: hasOptionParam(optionParamList, averageAgeId)
      ? createParam(optionParamList, AVERAGE_AGE_VALUE)
      : undefined,
  };
};

const hasOptionParam = (
  optionParamList: string[] | undefined,
  targetId: string | string[] | undefined
) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TODO: optionParamList が undefined になる可能性があるので要修正
  return optionParamList.some((id) => targetId?.includes(id));
};

/**
 * パラメータ作成
 * @param op opパラメータ
 * @param kodawariConstants こだわりid
 * @returns パラメータ
 */
const createParam = (
  op: string[] | undefined,
  kodawariConstants:
    | typeof EMPLOYMENT_VALUES
    | typeof HOLIDAY_AND_WAY_OF_WORKING_VALUE
    | typeof REQUIREMENT_VALUES
    | typeof WORKPLACE_ENVIRONMENT_VALUE
    | typeof BENEFITS_VALUE
    | typeof LANGUAGE_VALUE
    | typeof POSITIONS_VALUE
    | typeof AVERAGE_AGE_VALUE
) => {
  return (
    kodawariConstants
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore TODO: op が undefined になる可能性があるので要修正
      .filter((item) => op.includes(item.value))
      .map((item) => item.id)
  );
};
